/**
 * Subdomain Detection Utility
 * Detects if the current URL is an admin subdomain and provides routing logic
 */

export const isAdminSubdomain = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const hostname = window.location.hostname;
  return hostname.startsWith('admin.') || hostname === 'admin.iwishbag.com';
};

export const getBaseUrl = (): string => {
  if (typeof window === 'undefined') return '';
  
  const { protocol, hostname, port } = window.location;
  const portSuffix = port ? `:${port}` : '';
  
  return `${protocol}//${hostname}${portSuffix}`;
};

export const redirectToAdmin = (): void => {
  if (typeof window === 'undefined') return;
  
  const adminUrl = isAdminSubdomain() 
    ? '/admin' 
    : 'https://admin.iwishbag.com/admin';
    
  window.location.href = adminUrl;
};

export const getSubdomainConfig = () => {
  const isAdmin = isAdminSubdomain();
  
  return {
    isAdmin,
    defaultPath: isAdmin ? '/admin' : '/',
    title: isAdmin ? 'iWishBag Admin' : 'iWishBag',
    description: isAdmin 
      ? 'Admin dashboard for iWishBag international shopping platform'
      : 'International shopping made easy - Amazon, Flipkart, eBay to India & Nepal'
  };
};